export default __webpack_public_path__ + "static/media/our-merchants-icon.ba766a21.svg";